// 商户入驻注册路由
export default [
  {
    path: '/merchantsManage/personalRegist',
    component: () =>
      import('../pages/merchantsManage/register/personalRegist.vue'),
    name: 'personalRegist',
    title: '个体工商户',
    meta: {
      title: '个体工商户',
    },
  },
  {
    path: '/merchantsRegiset/enterpriseRegist',
    component: () =>
      import('../pages/merchantsManage/register/enterpriseRegist.vue'),
    name: 'enterpriseRegist',
    title: '企业商户',
    meta: {
      title: '企业商户',
    },
  },
  {
    path: '/merchantsRegiset/microRegister',
    component: () =>
      import('../pages/merchantsManage/register/microRegister.vue'),
    name: 'enterpriseRegist',
    title: '小微商户',
    meta: {
      title: '小微商户',
    },
  },
]
